import moengage from "@moengage/web-sdk";
import { moengageInitialize } from "./moengageEventsFunction";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const identifyUserAsync = async (id) => {
  if (!id || typeof id !== "string" || id.trim() === "") return;

  moengage.identifyUser(id);
  await delay(200);
};

const destroySessionSafe = () => {
  return new Promise((resolve) => {
    let resolved = false;

    // MoEngage destroy session
    moengage.destroy_session(() => {
      resolved = true;
      resolve();
    });

    // Fallback after 400ms if callback never fires
    setTimeout(() => {
      if (!resolved) resolve();
    }, 400);
  });
};

const setMoengageAttribute = async (setFun, value) => {
  if (value && typeof value === "string" && value.trim() !== "") {
    await setFun(value.trim());
  }
};

export const setupMoengageUser = async ({ verifyOtpData, moengageUserId }) => {
  try {
    if (!verifyOtpData) return;

    // 1️. Initialize SDK
    await moengageInitialize();

    // 2️. Ensure valid user id
    if (!moengageUserId || moengageUserId.trim() === "") {
      console.warn("MoEngage: Invalid user ID");
      return;
    }

    // 3️. Identify user
    await identifyUserAsync(moengageUserId);

    // 4️. Check existing identity
    const identities = await moengage.getUserIdentities();
    const existingId = identities?.uid;

    if (existingId && existingId !== moengageUserId) {
      await destroySessionSafe();
      await identifyUserAsync(moengageUserId);
      await delay(300);
    }

    // 5️. Set user attributes safely
    await setMoengageAttribute(moengage.add_mobile, moengageUserId);
    await setMoengageAttribute(moengage.add_first_name, verifyOtpData?.user?.firstname);
    await setMoengageAttribute(moengage.add_last_name, verifyOtpData?.user?.lastname);
    await setMoengageAttribute(moengage.add_email, verifyOtpData?.user?.email);

    console.log("MoEngage user setup completed successfully");
  } catch (error) {
    console.error("MoEngage setup error:", error);
  }
};
